function doRequest(axiosFunctions, method, ...params) {
  controlFrontendVersion(axiosFunctions);
  return axiosFunctions[method](...params);
}

export function getAxiosFunctions(axios) {
  return {
    get: axios.get,
    post: axios.post
  };
}

export function controlFrontendVersion(axiosFunctions) {
  axiosFunctions["get"]("/frontend/current-version").then(res => {
    let currentVersion = res.data.data;
    let savedVersion = localStorage.getItem("currentVersion");
    if (savedVersion !== currentVersion) {
      localStorage.setItem("currentVersion", currentVersion);
      if (savedVersion) {
        window.location.reload(true);
      }
    }
  });
}

export function injectVersionControlRequest(axios) {
  const baseFunctions = getAxiosFunctions(axios);
  axios.get = (url, config) => doRequest(baseFunctions, "get", url, config);
  axios.post = (url, data, config) =>
    doRequest(baseFunctions, "post", url, data, config);
}
